export var SignEncoding;
(function (SignEncoding) {
    SignEncoding["Hex"] = "hex";
    SignEncoding["Base64"] = "base64";
})(SignEncoding || (SignEncoding = {}));
